export const companyHostDeviceSid = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
